import { render } from "./EmployeePaySlipGenerateModal.vue?vue&type=template&id=067e0c8a&scoped=true"
import script from "./EmployeePaySlipGenerateModal.vue?vue&type=script&lang=js"
export * from "./EmployeePaySlipGenerateModal.vue?vue&type=script&lang=js"

import "./EmployeePaySlipGenerateModal.vue?vue&type=style&index=0&id=067e0c8a&scoped=true&lang=scss"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067e0c8a"]])

export default __exports__